import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

import {
  computed, onBeforeUnmount, onMounted, onUpdated, ref
} from 'vue';
import { observeCellResize } from '@shell/components/SortableTable/cell-resize';
import { escapeHtml } from '@shell/utils/string';

export interface CellLimits {
  minWidth?: number;
  maxWidth?: number;
  lineClamp?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LimitedCell',
  props: {
    limits: {}
  },
  setup(__props: any) {

/**
 * A cell's content kept within its column's `minWidth`, `maxWidth` and `lineClamp`. The limits sit
 * on this box rather than the cell: browsers ignore a table cell's max width, and a cell can't be
 * clamped to lines. Text the lines cut is offered whole as a tooltip, and only then
 */
const props = __props;

const box = ref<HTMLElement | null>(null);

const cutText = ref('');

const style = computed(() => ({
  minWidth:             props.limits.minWidth ? `${ props.limits.minWidth }px` : undefined,
  maxWidth:             props.limits.maxWidth ? `${ props.limits.maxWidth }px` : undefined,
  '-webkit-line-clamp': props.limits.lineClamp || undefined,
  lineClamp:            props.limits.lineClamp || undefined,
}));

/** Wrapped onto more lines than are shown, or a word too long for the widest line */
const measure = () => {
  const el = box.value;
  const cut = !!el && !!props.limits.lineClamp && (el.scrollHeight > el.clientHeight + 1 || el.scrollWidth > el.clientWidth + 1);

  // The tooltip draws HTML, and this is the cell's text
  cutText.value = cut ? escapeHtml((el?.textContent || '').trim()) : '';
};

let stopObserving = () => {};

onMounted(() => {
  measure();

  // The column's width follows the window and its neighbours, and with it the lines the text takes
  if (box.value) {
    stopObserving = observeCellResize(box.value, measure);
  }
});

onUpdated(measure);

onBeforeUnmount(() => stopObserving());

return (_ctx: any,_cache: any) => {
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref_key: "box",
    ref: box,
    class: _normalizeClass(["limited-cell", { clamped: !!__props.limits.lineClamp }]),
    style: _normalizeStyle(style.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6)), [
    [_directive_clean_tooltip, { content: cutText.value, placement: 'auto', popperClass: ['limited-cell-tooltip'] }]
  ])
}
}

})